import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const AIFloorPlanLanding = () => (
  <SeoLandingPage
    testIdPrefix="tool-floor-plan"
    pretitle="AI Tool · Floor Plans"
    title="Turn a rough sketch into"
    titleAccent="a clean floor plan"
    description="Upload a hand-drawn or photographed floor plan. Our AI redraws it as a crisp, agent-ready 2D plan in seconds — preserving your exact layout, room labels and proportions. Every output carries a Shopperden AI-generated watermark for transparency."
    ctaLabel="Try it now"
    ctaTo="/seller/create"
    secondaryCtaLabel="See pricing"
    secondaryCtaTo="/for-agents"
    bullets={[
      { title: 'Layout-preserving', body: 'AI keeps the exact same rooms, doors, walls and windows you sketched — only the lines get cleaner.' },
      { title: 'Country-styled', body: 'Match Rightmove (UK), 99acres / MagicBricks (IN) or Realtor.ca (CA) listing conventions automatically.' },
      { title: 'Watermarked', body: 'Every AI output is clearly stamped "Shopperden · AI Generated" so it cannot be passed off as a certified architectural drawing.' },
    ]}
    faq={[
      { q: 'How accurate is the redraw?', a: 'The AI preserves your exact room layout, proportions and labels. It only replaces messy lines with clean vector-style walls. It does not measure or certify dimensions — for surveys you need a RICS surveyor.' },
      { q: 'Can I use this for a planning application?', a: 'No. AI-generated plans are watermarked and explicitly labelled as informational only. Submit a certified plan from an architect / chartered surveyor for any planning, mortgage or legal use.' },
      { q: 'Is my sketch private?', a: 'Yes. Sketches are processed for the redraw only and not used to train any model. The original and enhanced versions are stored against your listing for your reference.' },
    ]}
    seoTitle="AI Floor Plan Generator — Sketch to clean 2D plan in seconds | Shopperden"
    seoDescription="Upload a rough sketch, get a clean estate-agent-ready 2D floor plan from AI. Layout-preserving, country-styled, Shopperden watermarked."
    softwareApplication={{
      name: 'Shopperden AI Floor Plan Generator',
      category: 'DesignApplication',
      subCategory: 'RealEstateApplication',
      description: 'AI-powered floor plan generator: turns a hand-drawn or photographed sketch into a clean, agent-ready 2D plan in seconds.',
      features: [
        'Layout-preserving redraw',
        'Country-styled output (UK / India / Canada)',
        'Watermarked AI provenance',
        'PNG / PDF export',
      ],
      rating: { value: '4.8', count: '142' },
    }}
  />
);

export default AIFloorPlanLanding;
